import { Injectable } from '@angular/core';
import { ApiService } from '../api/api.service';
import { Observable } from 'rxjs';
import {
  ApiResponseReader,
  ApiResponseService,
} from '../api/api-response.service';

@Injectable({
  providedIn: 'root',
})
export class IxbrlService {
  // This api version is needed for iXBRL agent
  //TODO: Update the api version and test the endpoints
  private readonly apiVersion: string = `v1/ixbrl/`;

  constructor(
    private apiService: ApiService,
    private apiResponseService: ApiResponseService
  ) {}

  /**Document Formatting endpoints */
  createDocFormatProject(file: File): Observable<ApiResponseReader | any> {
    const slug: string = `${this.apiVersion}` + `doc-format/create`;
    const formData = new FormData();
    formData.append('file', file);

    return this.apiResponseService.prepareResponseForReading(
      this.apiService.post(slug, formData, '')
    );
  }

  getFormatDocProjectById(id: string): Observable<ApiResponseReader> {
    const slug: string = `${this.apiVersion}` + `doc-format/project/${id}`;

    return this.apiResponseService.prepareResponseForReading(
      this.apiService.get(slug, {}, '')
    );
  }

  getProjects(): Observable<ApiResponseReader> {
    const slug: string = `${this.apiVersion}` + `doc-format/projects`;

    return this.apiResponseService.prepareResponseForReading(
      this.apiService.get(slug, {}, '')
    );
  }

  /**END of Document Formatting endpoints */
}
